/* eslint-disable react/prop-types */

import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import Loading from "components/Loading";
import ModalUI from "components/ModalUI";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { updateSetting } from "services/setting.routes";
import queryString from "utils/queryString";

export default function UpdateSettingModal({ modalInfo, setSettings, closeModal }) {
    const [information, setInformation] = useState({});
    const [loading, setLoading] = useState(false);
    const handleChange = (event) => {
        const { name, value } = event.target;
        setInformation({ ...information, [name]: value });
    };
    useEffect(() => {
        if (modalInfo?.item)
            setInformation({ value: modalInfo?.item?.value })
    }, [])

    const updateSettingItem = async () => {
        if (modalInfo?.item) {
            setLoading(true);
            updateSetting(modalInfo?.item?.name, queryString(information), (isOk, data) => {
                setLoading(false);
                if (!isOk) {
                    return toast.error(data.message);
                } else {
                    toast.success("تنظیمات ویرایش شد!");
                    setSettings(prevSetting => prevSetting.map(setting =>
                        setting.id === modalInfo.item.id ? { ...setting, ...information } : setting
                    ));
                    closeModal();
                }
            });
        }
    };
    return (
        <ModalUI open={modalInfo.state} handleClose={closeModal} style={{ minWidth: "600px" }}>
            <SoftBox py={3}>
                <Loading loading={loading} />
                <SoftBox component="form" role="form">
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} xl={12}>
                            <p style={{ fontSize: 14 }}>{modalInfo?.item?.name}</p>
                            <SoftBox mb={1} ml={0.5}>
                                <SoftTypography component="label" variant="caption" fontWeight="bold">
                                    مقدار
                                </SoftTypography>
                            </SoftBox>
                            <SoftInput name="value" value={information.value} onChange={handleChange}
                                type="text" placeholder="مقدار" />
                        </Grid>
                    </Grid>
                </SoftBox>
                <SoftButton style={{ marginTop: 20 }} onClick={updateSettingItem} variant="gradient" color="info">
                    ویرایش
                </SoftButton>
            </SoftBox>
        </ModalUI>
    )
}